export default __webpack_public_path__ + "static/media/leg.52509b01.png";